export default [
  {
    path: '/campanhas/calendario-promocional',
    component: () => import('@/modules/calendario-promocional/views/pages/CalendarioPromocional.vue'),
    meta: {
      title: 'Calendário promocional',
      breadcrumbs: [
        { name: 'Home', pathName: '/home' },
        { name: 'Campanhas', pathName: null, action: 'campanhas' },
        { name: 'Calendário promocional', pathName: null },
      ],
      pagePermission: 'campanhas/calendario_promocional',
    },
  },
]
